var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3916",
  "data-name": "Group 3916",
  transform: "translate(-8 -708)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_45",
  "data-name": "Ellipse 45",
  cx: 24,
  cy: 24,
  r: 24,
  transform: "translate(8 708)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3904",
  "data-name": "Group 3904",
  transform: "translate(-1106 735)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2671",
  "data-name": "Rectangle 2671",
  transform: "translate(1126 -13)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.6,
  y: 0.6,
  width: 22.8,
  height: 3.8,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2672",
  "data-name": "Rectangle 2672",
  transform: "translate(1127 -9)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 18,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.6,
  y: 0.6,
  width: 20.8,
  height: 16.8,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3333",
  "data-name": "Group 3333",
  transform: "translate(1131.009 4.532)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2673",
  "data-name": "Rectangle 2673",
  transform: "translate(-0.009 0.468)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2674",
  "data-name": "Rectangle 2674",
  transform: "translate(2.991 0.468)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2675",
  "data-name": "Rectangle 2675",
  transform: "translate(6.991 0.468)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2676",
  "data-name": "Rectangle 2676",
  transform: "translate(9.991 0.468)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2677",
  "data-name": "Rectangle 2677",
  transform: "translate(12.991 0.468)",
  fill: "none",
  stroke: "#2a9c27",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  fill: "none"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M5776,504.069l1.694,2.465,5.861-5.438",
  transform: "translate(-4641.234 -505.748)",
  fill: "none",
  stroke: "#2a9c27",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})))));
export default __webpack_public_path__ + "static/media/order-notification.e33e9595.svg";
export { SvgComponent as ReactComponent };